import { render } from "./TalentDetailPage.vue?vue&type=template&id=09c60eb7"
import script from "./TalentDetailPage.vue?vue&type=script&lang=js"
export * from "./TalentDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__